import type { TranslocoService } from '@jsverse/transloco';
import type { MerchantUserPrivilege } from '@core/api/model/merchantUserPrivilege';

export function translatePrivilegeLabel(
  translocoService: TranslocoService,
  privilege: MerchantUserPrivilege,
  lang: string,
): string {
  const globalKey = `users.privilege_labels.${privilege}`;
  const globalLabel = translocoService.translate(globalKey, {}, lang);
  if (globalLabel !== globalKey) {
    return globalLabel;
  }

  const merchantKey = `merchant_details.users.privilege_labels.${privilege}`;
  const merchantLabel = translocoService.translate(merchantKey, {}, lang);
  if (merchantLabel !== merchantKey) {
    return merchantLabel;
  }

  return privilege;
}

export function translatePrivilegeLabels(
  translocoService: TranslocoService,
  privileges: readonly MerchantUserPrivilege[],
  lang: string,
  emptyLabelKey: string,
): string {
  if (privileges.length === 0) {
    return translocoService.translate(emptyLabelKey, {}, lang);
  }

  return privileges
    .map((privilege) => translatePrivilegeLabel(translocoService, privilege, lang))
    .join(', ');
}
